export default __webpack_public_path__ + "static/media/background-mobile.892970c8.jpg";